import { Component, OnInit, Input, Output, OnChanges, EventEmitter, trigger, state, style, animate, transition } from "@angular/core";

@Component({
    selector: "modal-header",
    template: `<ng-content></ng-content>`
})

export class ModalHeader {
}

@Component({
    selector: "modal-content",
    template: `<ng-content></ng-content>`
})

export class ModalContent {
}

@Component({
    selector: "modal-footer",
    template: `<ng-content></ng-content>`
})

export class ModalFooter {
}

@Component({
    selector: "app-dialog",
    template: require("./dialog.component.html"),
    animations: [
        trigger("dialog", [
            transition('void => *', [
                style({ transform: 'scale3d(.3, .3, .3)' }),
                animate(100)
            ]),
            transition('* => void', [
                animate(100, style({ transform: 'scale3d(.0, .0, .0)' }))
            ])
        ])
    ]
})

export class ModalComponent implements OnInit {

    @Input() modalClass: string;

    @Input() closeOnEscape = true;

    @Input() closeOnOutsideClick = true;

    @Input() title: string;

    @Input() hideCloseButton = false;

    @Input() cancelButtonLabel: string;

    @Input() submitButtonLabel: string;

    @Input() visible: boolean;

    @Output() visibleChange = new EventEmitter<boolean>();

    ngOnInit() { }

    close() {
        this.visible = false;
        this.visibleChange.emit(this.visible);
    }
}


// WEBPACK FOOTER //
// ./app/common/dialog/dialog.component.ts